/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  useRouteError
} from 'react-router-dom';
import { BaseLayout } from '@/layouts';

const Home = lazy(() => import('@/views/Home'));
const SectionSelect = lazy(() => import('@/views/SectionSelect'));
const TimeSelect = lazy(() => import('@/views/TimeSelect'));
const ReservationInfo = lazy(() => import('@/views/ReservationInfo'));
const Cancel = lazy(() => import('@/views/Cancel'));
const NotFound = lazy(() => import('@/views/NotFound'));

function RootErrorBoundary() {
  const error = useRouteError() as Error;
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    location.reload();
  }
  return null;
}

const lazyView = (view: JSX.Element) => {
  return <Suspense fallback="Loading...">{view}</Suspense>;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      <Route path="/" element={<BaseLayout />}>
        <Route path=":bookingId/:token" index element={lazyView(<Home />)} />
        <Route
          path="/section-select/:bookingId/:token/:depOrArr"
          element={lazyView(<SectionSelect />)}
        />
        <Route
          path="/time-select/:bookingId/:token/:depOrArr"
          element={lazyView(<TimeSelect />)}
        />
        <Route
          path="/cancel/:bookingId/:token/:depOrArr"
          element={lazyView(<Cancel />)}
        />
        <Route
          path="/reservation-info/:bookingId/:token/:depOrArr"
          element={lazyView(<ReservationInfo />)}
        />
        <Route path="*" element={lazyView(<NotFound />)} />
      </Route>
    </Route>
  )
);

export default router;
